module.exports = __webpack_public_path__ + "static/media/footerAeroLogo.7799dc41.svg";